import React, { FunctionComponent } from 'react';
import {route} from 'b302-frontend-library';

import NavBar from '../../layout/NavBar';
import NavLink from '../../layout/navbar/NavLink';

interface Props {}

const AdminNavBar: FunctionComponent<Props> = () => {

    return (
        <NavBar className={'navbar--admin'}>
            <NavLink to={route('admin-dashboard')}>
                Dashboard
            </NavLink>

            <NavLink to={route('admin-universities')}>
                Universities
            </NavLink>

            <NavLink to={route('admin-countries')}>
                Countries
            </NavLink>

            <NavLink to={route('admin-whitelist')}>
                Whitelist
            </NavLink>

            <NavLink to={route('admin-subject-areas')}>
                Subject areas
            </NavLink>
        </NavBar>
    );
};

export default AdminNavBar;
